export default __webpack_public_path__ + "static/media/queen.0d48dbe6.png";